import { ErrorOutline } from "@mui/icons-material";
import { Box, Stack, Typography } from "@mui/material";
import { Button } from "../../buttons/Button";

interface IProps {
    /**
     * Callback to close the dialog
     */
    onClose: () => void;
    /**
     * The subject of the error
     */
    subject: string;
    /**
     * The error description
     */
    description?: string;
}

/**
 * Component to show an error message when the mutation fails
 */
export const DialogMutationError = ({
    onClose,
    subject,
    description,
}: IProps) => {
    return (
        <>
            <ErrorOutline color={"error"} sx={{ width: 48, height: 48 }} />
            <Stack alignItems={"center"}>
                <Typography variant="h6" fontWeight={600}>
                    An Error Occurred
                </Typography>

                <Typography variant={"body2"} color={"textSecondary"}>
                    {description || `The ${subject} couldn't be saved.`}
                </Typography>
            </Stack>

            <Box flexGrow={1} />

            <Box>
                <Button
                    type="button"
                    variant="outlined"
                    color="darkSharp"
                    sx={{ borderRadius: 2, py: 1, minWidth: 180 }}
                    fullWidth
                    onClick={onClose}
                >
                    Close
                </Button>
            </Box>
        </>
    );
};
